class AdpTypeaheadController {
  constructor() {
    this.name = 'adpTypeahead';
  }
}

export default AdpTypeaheadController;



// WEBPACK FOOTER //
// ./src/app/components/adpTypeahead/adpTypeahead.controller.js